export interface Config {
    apiStandard: string;
    apiSimulation: string;
    oauth2: {
        authorizationServerHost: string;
        clientId: string;
        redirectUri: string;
    }
}

export type Env = "local" | "production";

export const APTA_API = process.env.APTA_API ?? "";
export const APTA_WEB = process.env.APTA_WEB ?? "";

export function getEnv(): Env {
    const { host } = window.location;

    if (host.includes("platformtennisindex")) {
        return "production";
    }

    return "local";
}

// ngrok is for local development
const ngrokCallback = "";

export const config: Config = {
    oauth2: {
        authorizationServerHost: process.env.AUTH_SERVER_HOST ?? "",
        redirectUri: getEnv() === "production" ? `${APTA_WEB}/redirect` : `${ngrokCallback}/redirect`,
        clientId: process.env.AUTH_CLIENT_ID ?? "",
    },
    apiSimulation: getEnv() === "production" ? APTA_API : "http://127.0.0.1:5000",
    apiStandard: getEnv() === "production" ? APTA_API : "http://127.0.0.1:3000",
};
